import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4" }
const _hoisted_2 = { class: "flex justify-center md:justify-start flex-wrap flex-row md:mr-auto md:ml-0 mx-auto w-full" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "space-y-8 divide-y divide-gray-200 bg-white py-3 border-b text-center" }
const _hoisted_5 = { class: "flex items-center justify-center sm:justify-evenly xs:justify-evenly flex-wrap" }
const _hoisted_6 = { class: "px-5 w-full flex-1" }
const _hoisted_7 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_8 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "md:ml-4" }
const _hoisted_11 = { class: "relative w-48" }
const _hoisted_12 = { class: "block truncate" }
const _hoisted_13 = { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_14 = {
  class: /*#__PURE__*/_normalizeClass([
                          'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                        ])
}
const _hoisted_15 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass([
                            'absolute inset-y-0 right-0 flex items-center pr-4 pl-5',
                          ])
}
const _hoisted_16 = { class: "max-w-lg w-64 lg:max-w-xs" }
const _hoisted_17 = { class: "relative text-gray-600 focus-within:text-gray-600" }
const _hoisted_18 = { class: "pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center" }
const _hoisted_19 = { class: "max-w-lg w-64 lg:max-w-xs" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_21 = { class: "relative text-gray-600 focus-within:text-gray-600" }
const _hoisted_22 = { class: "pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center" }
const _hoisted_23 = { class: "flex align-middle mx-5" }
const _hoisted_24 = { class: "px-8 py-6" }
const _hoisted_25 = { class: "space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center" }
const _hoisted_26 = { key: 0 }

import { AxiosInstance } from 'axios'
import { useRouter } from 'vue-router'
import { translate } from '@/utils/tools'
import { ticketStatusColors } from '@/utils/ticket-config'
import { inject, onMounted, ref, watch } from 'vue'
import { SearchIcon, FilterIcon, EyeIcon } from '@heroicons/vue/outline'
import Navbar from '@/components/tools/Navbar.vue'
import DataTable from '@/components/tools/DataTable.vue'
import Pagination from '@/components/tools/Pagination.vue'
import TicketAdvanceFilterDialog from '@/components/dialogs/TicketAdvanceFilterDialog.vue'
import CreateTicketBaseDialog from '@/components/dialogs/ticket-managements/CreateTicketBaseDialog.vue'
import Toast from '@/components/tools/Toast.vue'
import { check_require_field } from '@/utils/ticket-validator'
import "dayjs/locale/th";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useStore } from 'vuex'
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TicketManager',
  setup(__props) {

dayjs.extend(localizedFormat);
const router = useRouter()
const store = useStore()
const axios = inject('$axios') as AxiosInstance
const pageConfig = ref({
  page: 1,
  rowsPerPage: 10,
  dataLength: 0,
  search: '',
  filters: {},
})
const toastConfig = ref({
  show: false,
  message: '',
  success: true,
  manual_close: false,
  warning:false
})
const pageData = ref([])
const columns = ref([
  {
    label: translate('messages.ticketManagement.ticketId'),
    field: 'id',
    align: "left",
  },
  {
    label: translate('messages.ticketManagement.ticketTopic'),
    field: 'caseType',
    align: "left",
  },
  {
    label: translate('messages.ticketManagement.userUsername'),
    field: 'userUsername',
    align: "left",
  },
  {
    label: translate('messages.ticketManagement.ticketOwner'),
    field: 'adminUsername',
    align: "left",
  },
  {
    label: translate('messages.ticketManagement.status'),
    field: 'status',
    align: "left",

    class: () => `capitalize rounded text-white`,

    style: (data: any) => `background-color: ${ticketStatusColors[data.status]}`,
  },
  {
    label: translate('messages.ticketManagement.createdAt'),
    field: 'createdAt',
    align: "left",
    format: (data: any) => dayjs(data.createdAt).format("YYYY-MM-DD HH:mm:ss"),
  },
  {
    isElement: true,
    isFunction: true,
    element: EyeIcon,
    elementClass: 'w-5 h-5 cursor-pointer',
    align: "left",
    function: (data: any) => router.push({ path: `/ticket-manager/${data.id}` }),
  },
])

const isLoaded = ref<boolean>(false)
const formLoading = ref<boolean>(false)
const showCreateTicketModal = ref<boolean>(false)
const showAdvanceFilterModal = ref<boolean>(false)
const showTicketDetailDialog = () => console.log('show detail')
const fromDate = ref("");
const toDate = ref("");

const startDate = dayjs();
const diff = startDate.diff("2021-07-01", "months");
let months: any = ref([]);
const selected = ref({
  label: dayjs().startOf("month").format("MM/YYYY"),
  value: dayjs().endOf("month").format("YYYY-MM-DD"),
});


const getPageData = async () => {
  let fromParams = dayjs(fromDate.value).startOf("month").format();
  let toParams = dayjs(toDate.value).endOf("month").format();
  if (selected.value.label == "Yesterday") {
    fromParams = dayjs(fromDate.value)
      .hour(0)
      .minute(0)
      .second(0)
      .format();
    toParams = dayjs(toDate.value)
      .hour(23)
      .minute(59)
      .second(59)
      .format();
  } else if (selected.value.label == "Today") {
    fromParams = dayjs(fromDate.value)
      .hour(0)
      .minute(0)
      .second(0)
      .format();
    toParams = dayjs(toDate.value)
      .hour(23)
      .minute(59)
      .second(59)
      .format();
  }
  const { search, page, rowsPerPage, filters } = pageConfig.value
  isLoaded.value = false
  const ticketList = await axios
    .post<any>(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/ticket/list`, {
      page,
      search,
      filters,
      from: fromParams,
      to: toParams,
      operatorId: store.state.selectedOperator.operatorId,
      pageSize: rowsPerPage,
    })
    .then((response) => response.data)
  pageData.value = ticketList.tasks
  pageConfig.value.dataLength = ticketList.tasks.length
  showAdvanceFilterModal.value = false
  isLoaded.value = true
}

const onFilterSubmit = (filters: any) => {
  pageConfig.value.filters = filters
  getPageData()
}

const filterByMonth = (payload: any) => {
  let from: any = dayjs(payload.value).startOf("month").format("YYYY-MM-DD");
  let to: any = dayjs(payload.value).endOf("month").format("YYYY-MM-DD");
  if (payload.label == "Yesterday") {
    from = dayjs(payload.value)
      .add(-1, "day")
      .hour(0)
      .minute(0)
      .second(0)
      .format("YYYY-MM-DD");
    to = dayjs(payload.value)
      .hour(23)
      .minute(59)
      .second(59)
      .format("YYYY-MM-DD");
  } else if (payload.label == "Today") {
    from = dayjs(payload.value)
      .hour(0)
      .minute(0)
      .second(0)
      .format("YYYY-MM-DD");
    to = dayjs(payload.value)
      .hour(23)
      .minute(59)
      .second(59)
      .format("YYYY-MM-DD");
  }
  toDate.value = to;
  fromDate.value = from;
}

const onCreateTicket = async ({ formData, form_name }: { formData: FormData; form_name: string }) => {
  formLoading.value = true
  if (!formData.has('user_id')) formData.set('user_id', '')
  const validate_result = check_require_field(form_name, formData)
  if (validate_result.validated) {
    const attachmentsFile = formData.get('attachments') as File;
    if ((attachmentsFile.size / (1024 * 1024)) > 10) { //>10mb
      toastConfig.value.show = true
      toastConfig.value.success = false
      toastConfig.value.message = `ไฟลต้องไม่เกิน 10 MB`
      toastConfig.value.manual_close = true
      formLoading.value = false
      return false;
    }

    toastConfig.value.manual_close = false
    const ticket = await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/ticket/create`,
      formData
    )
    console.log('[E] ~ onCreateTicket ~ ticket:', ticket)

    toastConfig.value.show = true
    if (ticket.data) {
      toastConfig.value.success = ticket.data.is_success
      if (ticket.data.is_success) {
        toastConfig.value.message = 'Ticket Created'
        showCreateTicketModal.value = !showCreateTicketModal.value
      } else toastConfig.value.message = 'Create Ticket Failed'
    } else {
      toastConfig.value.success = false
      toastConfig.value.message = 'Create Ticket Failed'
    }
  } else {
    toastConfig.value.show = true
    toastConfig.value.success = false
    toastConfig.value.message = `Missing fields ${validate_result.missing_field}`
    toastConfig.value.manual_close = true
  }
  formLoading.value = false
}

const searchRage = async (e: any) => {
  let from = dayjs(fromDate.value).hour(0).minute(0).second(0);
  let to = dayjs(toDate.value).hour(23).minute(59).second(59);
  if (
    (e.code == "Enter" ||
      e.code == "NumpadEnter" ||
      e.type == "change" ||
      e.keyCode == 13) &&
    from.isValid() &&
    to.isValid() &&
    from.isBefore(to)
  ) {
    isLoaded.value = false;
    const { search, page, rowsPerPage, filters } = pageConfig.value
    isLoaded.value = false
    const ticketList = await axios
      .post<any>(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/ticket/list`, {
        page,
        search,
        filters,
        from: from.format(),
        to: to.format(),
        operatorId: store.state.selectedOperator.operatorId,
        pageSize: rowsPerPage,
      })
      .then((response) => response.data)
    pageData.value = ticketList.tasks
    pageConfig.value.dataLength = ticketList.tasks.length
    showAdvanceFilterModal.value = false
    isLoaded.value = true

  }
};
const setMonth = async () => {
  const today = {
    label: "Today",
    value: dayjs().format(),
  };
  months.value.unshift(today);

  for (let i = 0; i <= diff; i++) {
    months.value.push({
      label: dayjs("2021-07-01").add(i, "month").format("MM/YYYY"),
      value: dayjs("2021-07-01").add(i, "month").format(),
    });
  }

  months.value.sort((a: any, b: any) => (dayjs(b.value).isAfter(dayjs(a.value)) ? 1 : -1));

  const yesterday = {
    label: "Yesterday",
    value: dayjs().add(-1, "day").format(),
  };
  months.value.unshift(yesterday);
  selected.value = months.value[1]
  filterByMonth(selected.value)
}
const exports = async () => {
  isLoaded.value = false
  // let fromParams = dayjs(selected.value.value).startOf("month").format();
  // let toParams = dayjs(selected.value.value).endOf("month").format();
  // await axios
  //   .post<any>(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/ticket/export`
  //   ),null,
  //         {
  //           params: {
  //             operatorId: store.state.selectedOperator.operatorId,
  //             from: fromParams,
  //             to: toParams,
  //           },
  //         }
  //   .then(({ data }) => {
  //     window.open(data);
  //   });
  // isLoaded.value = true

  let fromParams = dayjs(selected.value.value).startOf("month").format();
  let toParams = dayjs(selected.value.value).endOf("month").format();
  axios
    .post(
      process.env.VUE_APP_API_ENDPOINT +
      "/admin/api/v1/ticket/export",
      {
        operatorId: store.state.selectedOperator.operatorId,
        from: fromParams,
        to: toParams,
        userId: store.state.user.id
      }
    )
    .then(({ data }) => {
      window.open(data);
    });
  isLoaded.value = true

};


watch(toastConfig.value, (val) => {
  if (val.show == false && toastConfig.value.message == 'Ticket Created') getPageData()
})

watch(
  pageConfig,
  () => {
    getPageData()
  },
  { deep: true }
)

onMounted(async () => {
  await setMonth()
  await getPageData()
  console.log(store.state.user.permissions.includes('EXPORT.TICKET'))
})

return (_ctx: any,_cache: any) => {
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.ticketManagement.ticketManager')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(SearchIcon), {
                      class: "h-5 w-5",
                      "aria-hidden": "true"
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    maxlength: "10",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
                    placeholder: _ctx.$t('messages.ticketManagement.search'),
                    class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                  }, null, 8, _hoisted_9), [
                    [_vModelText, pageConfig.value.search]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(Listbox), {
                  as: "div",
                  modelValue: selected.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selected).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(ListboxButton), { class: "bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(selected.value.label), 1),
                          _createElementVNode("span", _hoisted_13, [
                            _createVNode(_component_SelectorIcon, {
                              class: "h-5 w-5 text-gray-400",
                              "aria-hidden": "true"
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_Transition, {
                        "leave-active-class": "transition ease-in duration-100",
                        "leave-from-class": "opacity-100",
                        "leave-to-class": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ListboxOptions), { class: "absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(months), (month) => {
                                return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                  as: "template",
                                  key: month.label,
                                  value: month,
                                  onClick: ($event: any) => (filterByMonth(month), getPageData())
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("li", _hoisted_14, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass([
                            selected.value.value == month.value
                              ? 'font-semibold'
                              : 'font-normal',
                            'block truncate text-left',
                          ])
                                      }, _toDisplayString(month.label), 3),
                                      (selected.value.value == month.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                            _createVNode(_component_CheckIcon, {
                                              class: "h-5 w-5",
                                              "aria-hidden": "true"
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("messages.dailyReport.from")) + " : ", 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "from",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fromDate).value = $event)),
                    maxlength: "10",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (searchRage($event))),
                    class: "block w-full bg-white py-2 pl-14 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
                    placeholder: "From",
                    type: "date",
                    name: "from"
                  }, null, 544), [
                    [_vModelText, fromDate.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("messages.dailyReport.to")) + ": ", 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "from",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((toDate).value = $event)),
                    maxlength: "10",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (searchRage($event))),
                    class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
                    placeholder: "To",
                    type: "date",
                    name: "to"
                  }, null, 544), [
                    [_vModelText, toDate.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                (_unref(store).state.user.permissions.includes('EXPORT.TICKET'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (exports())),
                      class: "ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "mr-2",
                        icon: ['far', 'file-export']
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.dailyReport.exportReport")), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500",
                  onClick: _cache[7] || (_cache[7] = () => (showAdvanceFilterModal.value = true))
                }, [
                  _createVNode(_unref(FilterIcon), { class: "h-5 w-5" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('messages.ticketManagement.advanceFilter')), 1)
                ]),
                _createElementVNode("button", {
                  class: "ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500",
                  onClick: _cache[8] || (_cache[8] = () => (showCreateTicketModal.value = true))
                }, _toDisplayString(_ctx.$t('messages.ticketManagement.createTicket')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_font_awesome_icon, {
          class: "text-gray-500",
          icon: ['fas', 'circle-notch'],
          transform: "grow-6",
          spin: ""
        })
      ])
    ], 512), [
      [_vShow, !isLoaded.value]
    ]),
    (isLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: pageData.value,
            onShowDetailTable: showTicketDetailDialog
          }, null, 8, ["columns", "data"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[9] || (_cache[9] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(TicketAdvanceFilterDialog, {
      show: showAdvanceFilterModal.value,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((showAdvanceFilterModal).value = $event)),
      onOnSubmit: onFilterSubmit
    }, null, 8, ["show"]),
    _createVNode(CreateTicketBaseDialog, {
      loading: formLoading.value,
      "onUpdate:loading": _cache[11] || (_cache[11] = ($event: any) => ((formLoading).value = $event)),
      show: showCreateTicketModal.value,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((showCreateTicketModal).value = $event)),
      onOnCreateTicket: onCreateTicket
    }, null, 8, ["loading", "show"]),
    _createVNode(Toast, {
      show: toastConfig.value.show,
      "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((toastConfig.value.show) = $event)),
      message: toastConfig.value.message,
      success: toastConfig.value.success,
      manual_close: toastConfig.value.manual_close
    }, null, 8, ["show", "message", "success", "manual_close"])
  ], 64))
}
}

})